import { render, staticRenderFns } from "./FormTemplatesFormCellTypeListCell.vue?vue&type=template&id=65b08bb0&"
import script from "./FormTemplatesFormCellTypeListCell.vue?vue&type=script&lang=js&"
export * from "./FormTemplatesFormCellTypeListCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VInput } from 'vuetify/lib/components/VInput';
installComponents(component, {VBtn,VInput})
